import { createAction } from "redux-actions";

// LOGIN USER
export const LOGIN_USER = "LOGIN_USER";
export const loginUser = createAction(LOGIN_USER);

export const LOGIN_USER_FAILURE = "LOGIN_USER_FAILURE";
export const loginUserFailure = createAction(LOGIN_USER_FAILURE);

export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const loginUserSuccess = createAction(LOGIN_USER_SUCCESS);

// SET USER DATA
export const SET_USER_DATA = "SET_USER_DATA";
export const setUserData = createAction(SET_USER_DATA);

// SET USER DATA SUCCESS
export const SET_USER_DATA_SUCCESS = "SET_USER_DATA_SUCCESS";
export const setUserDataSuccess = createAction(SET_USER_DATA_SUCCESS);

// REMOVE LOGIN DATA
export const REMOVE_LOGIN_DATA = "REMOVE_LOGIN_DATA";
export const removeLoginData = createAction(REMOVE_LOGIN_DATA);

// GET ALL MODEL
export const GET_ALL_MODEL = "GET_ALL_MODEL";
export const getAllModel = createAction(GET_ALL_MODEL);

export const GET_ALL_MODEL_FAILURE = "GET_ALL_MODEL_FAILURE";
export const getAllModelFailure = createAction(GET_ALL_MODEL_FAILURE);

export const GET_ALL_MODEL_SUCCESS = "GET_ALL_MODEL_SUCCESS";
export const getAllModelSuccess = createAction(GET_ALL_MODEL_SUCCESS);

// GET ALL EDITORS
export const GET_ALL_EDITORS = "GET_ALL_EDITORS";
export const getAllEditors = createAction(GET_ALL_EDITORS);

export const GET_ALL_EDITORS_FAILURE = "GET_ALL_EDITORS_FAILURE";
export const getAllEditorsFailure = createAction(GET_ALL_EDITORS_FAILURE);

export const GET_ALL_EDITORS_SUCCESS = "GET_ALL_EDITORS_SUCCESS";
export const getAllEditorsSuccess = createAction(GET_ALL_EDITORS_SUCCESS);

// ADD EDITOR
export const ADD_EDITOR = "ADD_EDITOR";
export const addEditor = createAction(ADD_EDITOR);

// Update EDITOR
export const UPDATE_EDITOR = "UPDATE_EDITOR";
export const updateEditor = createAction(UPDATE_EDITOR);
